/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TenantOrgProperties { 
    /**
     * Org id
     */
    org_id?: string;
    /**
     * White listed org
     */
    restricted?: boolean;
    /**
     * True if subscription capability is enabled for this org and VCDR service type else False
     */
    subscription_allowed?: boolean;
}

